<template>
  <div id="scoring-sample-report">
    <h2>Sample Feedback Report</h2>

    <br />

    <div class="report-container col-md-10 col-md-offset-1">
      <div class="row">
        <div class="col-md-12 pt-15">
          <Overall
            class="no-border panel-shadow pb-15 pt-5"
            :score="60"
            :scoring-method="scoringMethod"
          >
            <h3 slot="header" class="ml-15">Overall Performance</h3>
          </Overall>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <DevIndex
            class="no-border panel-shadow pb-15 pt-5"
            :chartdata="devIndex.chartData"
            :message="devIndex.message"
          >
            <h3 slot="header" class="ml-15">Development Index</h3>
          </DevIndex>
        </div>
      </div>

      <template v-if="isSelfAssessment">
        <div class="row">
          <div class="col-md-12">
            <SelfAwareness
              class="no-border panel-shadow pb-15 pt-5"
              :score="1"
              :message="selfAwareness.message"
            >
              <h3 slot="header" class="ml-15">Self Awareness</h3>
            </SelfAwareness>
          </div>
        </div>
      </template>

      <div class="row">
        <div class="col-md-12">
          <SkillGap
            class="no-border panel-shadow pb-15 pt-5"
            id="skill-gap-component"
            :skills="selfAwarenessSkills"
            :isSelfAssessment="isSelfAssessment"
          >
            <h3 slot="header" class="ml-15">
              Skill <template v-if="isSelfAssessment"> Gap </template>
              <template v-else> Score </template>
            </h3>
          </SkillGap>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';

  import Overall from '@student/../pages/Report/components/Overall.vue';
  import DevIndex from '@student/../pages/Report/components/DevIndex.vue';
  import SelfAwareness from '@student/../pages/Report/components/SelfAwareness.vue';
  import SkillGap from '@student/../pages/Report/components/SkillGap.vue';

  export default {
    name: 'SampleReport',

    props: {
      skills: {
        required: true,
        type: Object,
      },
    },

    data() {
      return {
        toggleKeys: {},
        devIndex: {
          chartData: {
            data: [
              [0, 0, 0],
              [0, 1, 0],
              [0, 2, 0],
              [1, 0, 0],
              [1, 1, 0],
              [1, 2, 0],
              [2, 0, 0],
              [2, 1, 0],
              [2, 2, 0],
              [3, 0, 1],
              [3, 1, 0],
              [3, 2, 0],
            ],
            yCategories: ['Novice', 'Intermediate', 'Advanced'],
            xCategories: [
              'Inconsistently',
              'Somewhat inconsistently',
              'Somewhat consistently',
              'Consistently',
            ],
          },
          message: `Your development index shows your current level of skill proficiency is at the Novice level.
         Across all these skills, you Consistently demonstrated this Intermediate level of proficiency.
          Your ultimate goal for professional development is to consistently demonstrate an advanced level across all these skills.`,
        },
        selfAwareness: {
          message: `Your self-awareness index is a 1. This score reflects how accurately your self-assessments match the objective assessments produced by CapsimInbox. 
        Higher scores equate to more accurate self-awareness. Your score indicates that you are currently very low in self-awareness accuracy. 
        When you are inaccurate, it is due to over-rating yourself It is important to recognize that an accurate understanding of your skills is the essential first step to improving these skills.`,
          score: 1,
        },
      };
    },

    components: {
      Overall,
      DevIndex,
      SelfAwareness,
      SkillGap,
    },

    computed: {
      ...mapState('editMode/version', [
        'versionConfig',
        'customPageKeysArray',
        'onboardTemplateKey',
      ]),

      scoringMethod: (vm) => vm.versionConfig.scoringMethod,
      isSelfAssessment() {
        if (this.onboardTemplateKey === 3) {
          if (this.customPageKeysArray.length > 0) {
            for (let obj of this.customPageKeysArray) {
              if (obj.FK_onboardPageKey === 1) {
                return true;
              }
            }
          }

          return false;
        }

        return true;
      },

      selfAwarenessSkills() {
        return Object.values(this.skills).reduce((acc, skill) => {
          acc[skill.skillKey] = {
            ...skill,
            gameScore: 50,
            selfScore: 25,
          };

          return acc;
        }, {});
      },
    },
  };
</script>
<style lang="scss">
  #scoring-sample-report {
    .no-border {
      border: none;
    }

    .lead {
      font-size: 16px;
      font-weight: 500;
    }

    .panel-shadow {
      box-shadow: 0 1px 5px 2px rgba(0, 0, 0, 0.05);
    }

    #skill-gap-component {
      button[data-toggle='popover'] {
        background: none;
        border: none;
      }
    }

    .report-container {
      background: #f4f4f4;
    }
  }
</style>
